export default [
  // Standard textfield validation options will be inherited from base form
  // Add any custom validation options here if needed
];
